;(function($){
	$.fn.daterangepicker.locale['en'] = {
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        fromLabel: 'From',
        toLabel: 'To',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        todayLabel: 'Today',
        yesterdayLabel: 'Yesterday',
        thisMonthLabel: 'This Month',
        lastMonthLabel: 'Last Month',
        last30DaysLabel: 'Last 30 Days',
        last7DaysLabel: 'Last 7 Days',
        currentPeriodLabel: 'Current Period',
        foreverPeriodLabel: 'Forever'
    };
}(jQuery));